import { Link } from "react-router-dom";
import React, { useState } from "react";
const ArrangementenMenu = ({ token, username }) => {
  const [isActive, setIsActive] = useState(false);
  if (username.bedrijf && username.bedrijf.modules.includes("arrangementen")) {
    if (token.role === "admin" || token.role === "manager" || token.role === "medewerker" || token.role === "ervaringeigenaar") {
      return (
        <li className="treeview">
          <a className="cursurhand" onClick={() => setIsActive(!isActive)}>
            <i className="fa-solid fa-utensils"></i> <span>Beheer Arrangementen</span>
            <span className="pull-right-container">
              <i className="fa fa-angle-left pull-right" />
            </span>
          </a>
          <ul className={isActive ? "treeview-menu menu-open" : "treeview-menu "}>
            <li>
              <Link to="/arrangementen" onClick={() => setIsActive(!isActive)}>
                <i className="fa-solid fa-utensils"></i> <span>Arrangementen</span>
              </Link>
            </li>
            {token.role === "admin" ||
              token.role === "manager" ||
              (token.role === "medewerker" && (
                <li>
                  <Link to="/arrangementen/toevoegen" onClick={() => setIsActive(!isActive)}>
                    <i className="fa fa-utensils" />
                    <span>Arrangementen Toevoegen</span>
                  </Link>
                </li>
              ))}
          </ul>
        </li>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
};
export default ArrangementenMenu;
